export const getMimeType = (url: string) => {
  const extension = url.split('.').pop()?.toLowerCase()
  if (extension === 'png') return 'image/png'
  return 'image/jpeg'
}

export const getFileName = (url: string) => {
  try {
    const pathname = new URL(url).pathname
    return pathname.split('/').pop() || 'image'
  } catch {
    return 'image'
  }
}
